import { render, staticRenderFns } from "./question-set-card.vue?vue&type=template&id=001ac24e&scoped=true&"
import script from "./question-set-card.vue?vue&type=script&lang=js&"
export * from "./question-set-card.vue?vue&type=script&lang=js&"
import style0 from "./question-set-card.vue?vue&type=style&index=0&id=001ac24e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001ac24e",
  null
  
)

export default component.exports